
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casestudy/heineken",
      function () {
        return require("private-next-pages/casestudy/heineken.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casestudy/heineken"])
      });
    }
  